import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../_components/Header';
import { BusinessProfileActions } from '../_actions';
import Spinner from '../_components/Spinner';
import NoResults from '../_components/NoResults';
import { Table } from 'react-bootstrap';
import DropdownLastDays from '../_components/DropdownLastDays';
import ModalShowRejected from '../_components/ModalShowRejected';
import ArrowImg from '../_assets/new/arrow.png';

const tabs = [
  { key: 1, title: 'Todos' },
  { key: 2, title: 'Contratados' },
  { key: 3, title: 'En entrevista' },
  { key: 4, title: 'Pendientes' },
  { key: 5, title: 'Rechazados' },
];

function Applicants() {
  const dispatch = useDispatch();
  const { dataRequest, isLoading, isLoadingReport } = useSelector(
    (state) => state.businessProfileReducers
  );
  const [activeTab, setActiveTab] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [comments, setComments] = useState('');

  useEffect(() => {
    dispatch(BusinessProfileActions.GetApplicants());
  }, [dispatch]);

  function handleShow(nextComments) {
    setOpenModal(true);
    setComments(nextComments);
  }

  function handleClose() {
    setOpenModal(false);
  }

  function openComments(job) {
    handleShow(job.comments);
  }

  function renderTable() {
    if (isLoading) {
      return <Spinner />;
    }

    function renderTag(status) {
      if (status) {
        const states = {
          Hired: 'Contratado',
          Interview: 'Entrevista',
          Pending: 'Pendiente',
          Rejected: 'Rechazado',
        };
        return states[status] || status;
      }
      return status;
    }

    return (
      <Table striped hover className="table-principal">
        <thead>
          <tr>
            <th>NOMBRE</th>
            <th>SEXO</th>
            <th>EDAD</th>
            <th>PUESTO SOLICITADO</th>
            <th>SALARIO</th>
            <th>FECHA DE SOLICITUD</th>
            <th>ESTATUS</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {dataRequest?.results?.length ? (
            dataRequest.results.map((job) => (
              <tr key={job.id}>
                <td>{job.name}</td>
                <td>{job.genre}</td>
                <td>{job.age}</td>
                <td>{job.job_name}</td>
                <td>$ {job.salary}</td>
                <td>{job.created}</td>
                <td>
                  <span
                    className={
                      'tag ' +
                      job.status +
                      (job.status === 'Rejected' ? ' pointer' : '')
                    }
                    onClick={() => openComments(job)}
                  >
                    {renderTag(job.status)}
                  </span>
                </td>
                <td>
                  <Link to={'/applicants/' + job.id}>
                    <img src={ArrowImg} alt="Ver solicitante" />
                  </Link>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">
                <NoResults />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }

  function sendUrl(url) {
    dispatch(BusinessProfileActions.GetApplicants(url));
  }

  function changeTab(eventKey) {
    setActiveTab(eventKey);
    dispatch(BusinessProfileActions.SetTabApplicants(eventKey));
    dispatch(BusinessProfileActions.GetApplicants());
  }

  function downloadReport() {
    dispatch(BusinessProfileActions.DownloadApplicantsExport());
  }

  function handleDaysChange(days) {
    dispatch(BusinessProfileActions.SetApplicantsDays(days));
    dispatch(BusinessProfileActions.GetApplicants());
  }

  return (
    <div className="dashboard-home">
      <ModalShowRejected
        handleClose={handleClose}
        show={openModal}
        comments={comments}
      />
      <Header />
      <div className="container">
        <div className="vacancies-secction" style={{ marginBottom: '31px' }}>
          <div className="row">
            <div className="col-md-4">
              <span className="title">SOLICITANTES</span>
            </div>
            <div className="col-md-8 text-right buttons-report">
              <DropdownLastDays apply={handleDaysChange} />

              <button
                className="btn btn-primary float-right"
                onClick={downloadReport}
                disabled={isLoadingReport}
              >
                Descargar reporte
              </button>
            </div>
          </div>
        </div>

        <div className="table-paginator clear">
          <nav className="nav nav-tabs vacancies-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={
                  'nav-link' + (activeTab === tab.key ? ' active' : '')
                }
                onClick={() => changeTab(tab.key)}
              >
                {tab.title}
              </button>
            ))}
          </nav>
          {renderTable()}

          <div className="float-right">
            {dataRequest?.page * 10 - 9}-{dataRequest?.page * 10} de{' '}
            {dataRequest?.count} registros
            <button
              className="btn prev"
              disabled={!dataRequest?.previous}
              onClick={() => sendUrl(dataRequest?.previous)}
            ></button>
            <button
              className="btn next"
              disabled={!dataRequest?.next}
              onClick={() => sendUrl(dataRequest?.next)}
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Applicants };
